import { HttpContext } from "@angular/common/http";
import { Component, OnInit, inject } from "@angular/core";
import { ConfirmationService, MessageService } from "primeng/api";
import { Observable } from "rxjs";
import {
  EntityModelStudy,
  PagedModelEntityModelStudy,
  Study,
  StudyControllerService
} from "../../../../modules/lipidcompass-backend-client";
import { CrudAdapter } from "../../layouts/crud-table/crud-adapter";
import { ColumnFilterType, TableColumn } from "../../_models/table-column";
import { LoggingService } from "../../_services/logging.service";
import { CrudTableComponent } from "../../layouts/crud-table/crud-table.component";

@Component({
  selector: "app-admin-study",
  templateUrl: "./admin-study.component.html",
  styleUrls: ["./admin-study.component.css"],
  standalone: true,
  imports: [CrudTableComponent]
})
export class AdminStudyComponent implements OnInit {
  private controller = inject(StudyControllerService);
  private messageService = inject(MessageService);
  private confirmationService = inject(ConfirmationService);
  private loggingService = inject(LoggingService);

  columns: TableColumn[];
  filterFields: string[];
  crudAdapter: CrudAdapter<PagedModelEntityModelStudy, EntityModelStudy>;

  ngOnInit() {
    this.columns = [
      /*{ field: "id", header: "Id", filterType: ColumnFilterType.Text },*/
      {
        field: "id",
        header: "Id",
        filterType: ColumnFilterType.Text,
        content: value => value,
        visible: true
      },
      {
        field: "transactionUuid",
        header: "Transaction",
        filterType: ColumnFilterType.Text,
        content: value => value,
        visible: true
      },
      {
        field: "name",
        header: "Name",
        filterType: ColumnFilterType.Text,
        content: value => value,
        visible: true
      },
      {
        field: "description",
        header: "Description",
        filterType: ColumnFilterType.Text,
        content: value => value,
        visible: true
      },
      // {
      //   field: "version",
      //   header: "Version",
      //   filterType: ColumnFilterType.Text,
      //   content: (value) => value
      // },
      // {
      //   field: "uri",
      //   header: "Uri",
      //   filterType: ColumnFilterType.Text,
      //   content: (value) => value
      // },
      {
        field: "visibility",
        header: "Visibility",
        filterType: ColumnFilterType.Text,
        content: value => value,
        visible: true
      }
    ];
    this.filterFields = this.columns.map(value => {
      return value.field;
    });
    this.crudAdapter = new StudyEntryCrudAdapter(
      this.controller,
      this.messageService,
      this.confirmationService,
      this.loggingService
    );
  }
}
class StudyEntryCrudAdapter extends CrudAdapter<
  PagedModelEntityModelStudy,
  EntityModelStudy
> {
  constructor(
    private controller: StudyControllerService,
    messageService: MessageService,
    confirmationService: ConfirmationService,
    loggingService: LoggingService
  ) {
    super(messageService, confirmationService, loggingService);
  }

  get(
    page?: number,
    size?: number,
    sort?: Array<string>,
    observe?: "body",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: "application/hal+json";
      context?: HttpContext;
    }
  ): Observable<PagedModelEntityModelStudy> {
    return this.controller.studyGet(
      page,
      size,
      sort,
      observe,
      reportProgress,
      options
    );
  }

  edit(rowEntry: any): void {
    if (rowEntry) {
      // create edit form from Study object (rowEntry) with primeng over all fields

      // create a form with all fields of the Study object
      this.loggingService.debug(
        "AdminStudyComponent",
        "edit: " + JSON.stringify(rowEntry)
      );
      this.saveSingle(rowEntry).subscribe(
        response => {
          this.messageService.add({
            severity: "success",
            summary: "Successful",
            detail: "Submission edited",
            life: 3000
          });
        },
        error => {
          this.messageService.add({
            severity: "danger",
            summary: "Failed",
            detail: "Failed to edit id: " + rowEntry?.id,
            life: 3000
          });
        }
      );
    }
  }

  extractEntries(entries: any): EntityModelStudy[] {
    return <EntityModelStudy[]>entries?._embedded?.studies;
  }

  saveSingle(
    entity: EntityModelStudy,
    observe?: "body",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: "application/hal+json";
      context?: HttpContext;
    }
  ): Observable<EntityModelStudy> {
    return this.controller.studySaveSingle(
      <Study>entity,
      observe,
      reportProgress,
      options
    );
  }
  deleteById(
    id: string,
    observe?: "body",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: "application/hal+json";
      context?: HttpContext;
    }
  ): Observable<object> {
    return this.controller.studyDeleteById(id, observe, reportProgress, options);
  }
}
